export default {
    viewEvents: {
        'frontend-shell:navigate': 'navigate',
    },
    eventHandlers: {
        navigate(route, options) {
            Odigeo.Router.navigate(route, options);
        },
    },
};
